//@flow

import { config } from "../enviroment";
import axios from "axios";
import { commonService } from "../services/common.service";
import { authService } from "./auth.service";
import { accountsDetails } from "../actions/home.action";
import { store } from "../helpers";

export const refreshBearerService = {
  refreshBearerToken,
};


async function loginDetailsAPI(){
  authService.accountDetaisAfterLogin().then(accountInformation => {
    let bearer = JSON.parse(localStorage.getItem("bearer"));
    let { email, lastFourDigitsOfPhoneNumber, userName, ...accountInformationData } = accountInformation
    bearer.email = email
    bearer.lastFourDigitsOfPhoneNumber = lastFourDigitsOfPhoneNumber
    bearer.accountDetails = accountInformationData
    localStorage.setItem("bearer", JSON.stringify(bearer)
    );
    store.dispatch(accountsDetails())
  }).catch(accountInfoError => {
    if (accountInfoError.toString().includes("403")) {
      console.error("Error fetching latest data from c2m")
    }
  })
}

async function refreshBearerToken() {
  const bearer = JSON.parse(localStorage.getItem("bearer"));
  localStorage.setItem(
    "refreshsucess",
    false
  );
  if (bearer) {
    await axios
      .post(
        config.urls.REFRESH_BEARER,
        {
          grantType: "refresh_token",
          refreshToken: JSON.parse(localStorage.getItem("bearer"))?.refreshToken,
        },
        {
          headers: {
            oldAccessToken: JSON.parse(localStorage.getItem("bearer"))?.acessToken,
          },
        }
      )
      .then(function(response) {
        bearer.acessToken = response.data.access_token;
        bearer.refreshToken = response.data.refresh_token;
        localStorage.setItem(
          "bearer",
          commonService.encodeString(JSON.stringify(bearer))
        );
        localStorage.setItem(
          "refreshsucess",
          true
        );
      }).then(()=>{
        loginDetailsAPI()
      })
      .catch(function(err) {
        localStorage.setItem(
          "refreshsucess",
          false
        );
        const status = err.status || (err.response ? err.response.status : 0);
        if (status === 401 || status === 400) {
          commonService.logoutUser();
        }
      });
  } else {
    commonService.logoutUser();
  }
}
